import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';

import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
} from '../../utils/hookHelper';

import { sanitizedHTML } from '../../utils/Helper';

import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import UnderConstruction from '../../components/UnderConstruction';
import PageIntro from '../../components/PageIntro';
import NoMatch from '../NoMatch';

const StaticPage = (props) => {
  const {
    match = {},
    i18n,
    staticPage,
    allowCookies,
    enableTealium,
    enableAdGlare,
    siteConfig,
  } = props;
  const debouncePageLoading = useDebounceLoading(staticPage);
  const jsLoading = useDelayJsLoadiing(staticPage);
  const notFound = useNotFound(staticPage);

  usePage(match.params.pageName, 'Pages/Static Page');
  useAdGlare(i18n.locale, siteConfig, staticPage, enableAdGlare.status);
  useUnmountResetPage();

  const { locale } = i18n;
  const { data = {} } = staticPage || {};
  const content = ((data || {}).content || {}).content || {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // content
  const headline = dataContent.headline || '';
  const description = dataContent.description || '';
  const contentBody = dataContent.content_body || '';

  // HelmetMeta
  const { metadata = {} } = data || {};
  const publishDate = metadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');

  useTealium(
    i18n.locale,
    siteConfig,
    staticPage,
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const headlineEle = <>{headline && <PageIntro headline={headline} />}</>;

  const headlineDesc = (
    <>{description && <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(description) }} />}</>
  );

  const mainContent = (
    <>{contentBody && <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(contentBody) }} />}</>
  );

  const pageEle = (
    <div>
      {notFound ? (
        <NoMatch />
      ) : (
        <div>
          {headlineEle}
          <Container>
            {under_construction && <UnderConstruction />}
            {!under_construction && headlineDesc}
            {!under_construction && mainContent}
          </Container>
          {!under_construction && (
            <HelmetScript extraHead={extra_head} jsScript={js_script_block} />
          )}
        </div>
      )}
    </div>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={title} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  staticPage: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(StaticPage);

export { StaticPage as StaticPageComponent }; // <- For component Unit Test
export default connectStore;
